import {Mapper} from '@s-ui/domain'

/**
 * Mapper for favorites API response which includes both ads and contracts
 */
export default class HTTPUserFavoritesResponseMapper extends Mapper {
  /**
   * @param {Object} deps
   * @param {Mapper} deps.adMapper - Mapper for individual ad entities
   * @param {Mapper} deps.contractMapper - Mapper for individual contract entities
   * @param {Function} deps.valueObject - Value object factory for the combined response
   */
  constructor({adMapper, contractMapper, valueObject}) {
    super()
    this._adMapper = adMapper
    this._contractMapper = contractMapper
    this._valueObject = valueObject
  }

  /**
   * Maps API response containing both ads and contracts
   * @param {Object} response - The API response
   * @param {Array} response.ads - Array of favorite ads
   * @param {Array} response.contracts - Array of favorite contracts
   * @returns {Promise<UserFavoritesValueObject>} Combined favorites value object
   */
  map = async ({ads = [], contracts = []}) => {
    const userFavoriteAds = ads.map(this._adMapper.map)
    const userFavoriteContracts = await Promise.all(contracts.map(this._contractMapper.map))

    return this._valueObject({
      ads: userFavoriteAds,
      contracts: userFavoriteContracts,
      totalAds: ads.length,
      totalContracts: contracts.length
    })
  }
}
